import Link from "next/link";

export const Events = () => {
	const events = [
		{
			title: "Web3&クラウドハンズオン",
			date: "2024年12月24日",
			deadline: "2024年12月23日",
			descs: ["ハンズオン形式でNFTやクラウド", "について学べる体験型セミナー"],
			img: "/events/2024techfes/nabe.png",
			href: "/events/2024techfes/lecture",
		},
		{
			title: "DAO型高専ハッカソン　　",
			date: "2025年2月24日",
			deadline: "2025年1月1日",
			descs: [
				"決められた予算で企画・運営を行う",
				"参加者による運営型ハッカソン",
			],
			img: "/events/2024techfes/majo.png",
			href: "/events/2024techfes/hackathon",
		},
	];
	const subtitleCls = "md:col-span-3";
	const subContentCls = "md:col-span-9";
	return (
		<div className={"flex flex-col bg-black gap-4 py-16"}>
			<h2 className={"text-4xl text-white text-center"}>メインイベント</h2>
			<div className={"flex flex-col md:flex-row md:justify-center gap-4"}>
				{events.map((e, i) => (
					<Link href={e.href} key={e.title}>
						<div>
							<div
								className={
									"relative transform hover:scale-[1.03] transition duration-500"
								}
							>
								<img
									src={"/events/2024techfes/rotated_paper.svg"}
									className={"w-[32rem] max-w-[95%] mx-auto"}
									alt={"cover"}
								/>
								<div
									className={
										"absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 gap-4 flex flex-col justify-center w-max text-black"
									}
								>
									<p
										className={
											"font-bold text-2xl whitespace-nowrap text-center"
										}
									>
										{e.title}
									</p>
									<div
										className={
											"grid grid-cols-1 md:grid-cols-12 text-sm md:text-lg gap-1 md:gap-4"
										}
									>
										<p className={subtitleCls}>概要</p>
										<p className={subContentCls}>
											{e.descs.map((d) => (
												<span key={d}>
													<span className={"whitespace-nowrap"}>{d}</span>
													<br />
												</span>
											))}
										</p>
										<p className={subtitleCls}>開催日程</p>
										<p className={subContentCls}>{e.date}</p>
										<p className={subtitleCls}>応募〆切</p>
										<p className={subContentCls}>{e.deadline}</p>
									</div>
								</div>
							</div>
						</div>
					</Link>
				))}
			</div>
			<p className={"text-center"}>▲　詳細は上記をクリック　▲</p>
		</div>
	);
};
